import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LeaveService {
  constructor(private http: HttpClient) {}

  createLeave(payload: any) {
    return this.http.post(`${environment.apiUrl}/leave`, payload);
  }

  updateLeave(id: string, payload: any) {
    return this.http.put(`${environment.apiUrl}/leave/${id}`, payload);
  }

  deleteLeave(id: string) {
    return this.http.delete(`${environment.apiUrl}/leave/${id}`);
  }

  getLeaveById(id: string) {
    return this.http.get(`${environment.apiUrl}/leave/${id}`);
  }

  getPagedLeaves(payload: {
    pageIndex: number;
    pageSize: number;
    filters?: any;
    sortField?: string;
    sortOrder?: number | string;
  }) {
    return this.http.post(`${environment.apiUrl}/leave/get-paged`, payload);
  }

  getBalance(nurseId: string, date?: string) {
    const qs = date ? `?date=${encodeURIComponent(date)}` : '';
    return this.http.get(`${environment.apiUrl}/leave/balance/${nurseId}${qs}`);
  }

  preview(payload: any) {
    return this.http.post(`${environment.apiUrl}/leave/preview`, payload);
  }

  checkConflicts(payload: any) {
    return this.http.post(`${environment.apiUrl}/leave/check-conflicts`, payload);
  }

  updateReason(id: string, reason: string) {
    return this.http.patch(`${environment.apiUrl}/leave/${id}/reason`, { reason });
  }

  getByDateRange(startDate: string, endDate: string, nurseId?: string) {
    return this.http.post(`${environment.apiUrl}/leave/by-date-range`, {
      startDate,
      endDate,
      nurseId,
    });
  }
}
